<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<div ref="logistictrace_custom_form"></div>
				<vxe-grid ref="invoiceDetailTable" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<trade-box ref="tradeBox" :currentrow="currentrow" :invoiceNumber="invoiceNumber" :store="store" :checkeddata="checkeddata"  @submit="tradeBoxSubmit" :invoicedata="invoicedata" />
				<xwtrade-box ref="xwtradeBox" :currentrow="currentrow" :invoiceNumber="invoiceNumber" :store="store" @submit="xwtradeBoxSubmit" :invoicedata="invoicedata" />
				<sku-box ref="skuBox" :currentrow="currentrow" @submit="skuSubmit" />
				<goods-box ref="goodsBox" :currentrow="currentrow" @submit="goodsSubmit" />	
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
		
		
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "$input",
					"field": "cargoName",
					"title": "项目名称",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "spectrim",
					"title": "规格型号",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "amount",
					"title": "开票数量",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "orderId",
					"title": "线上单号",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "cargoId",
					"title": "发票明细ID",
					"value": null,
					"hidden": true,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 12,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import tradeBox from '../box/trade.vue'
	import xwtradeBox from '../box/xwtrade.vue'
	import skuBox from '../box/sku.vue'
	import goodsBox from '../box/goods.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			store: {
				default: () => {
					return {}
				}
			},
			invoicedata: {
				default: () => {
					return {}
				}
			},
			currentrow: {
				default: () => {
					return {}
				}
			},
			invoiceNumber: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '匹配商品',
				modal_width:800,
				modal_height:600,
				checkeddata:[],
				list_footerField:[
					{field:'nums',toFixed:2},
					{field:'tp_payment',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			tradeBoxSubmit(e){
				if(e.data){
					let data = e.data.map((item)=>{
						return {
							id:item.id,
							groupcode:item.spec_code,
							is_package:item.is_package,
							nums:item.tp_item_size,
							tp_payment:item.tp_payment,
						}
					})
					let tableData = this.getgrid().getTableData().tableData
					data.forEach((row)=>{
						let target = tableData.find((item)=>{
							return row.id == item.id
						})
						if(!target){
							this.getgrid().insert(row)	
						}
					})
					
				}			
			},
			xwtradeBoxSubmit(e){
				console.log(e)
				if(e.data){
					let data = [{
						groupcode:e.data.realskuId,
						is_package:1,
						nums:e.data.nums,
					}]
					let tableData = this.getgrid().getTableData().tableData
					data.forEach((row)=>{
						let target = tableData.find((item)=>{
							return row.id == item.id
						})
						if(!target){
							this.getgrid().insert(row)	
						}
					})
					
				}			
			},
			skuSubmit(e){
				if(e.data){
					let data = e.data.map((item)=>{
						return {
							groupcode:item.realskuId,
							is_package:1,
							nums:null,
						}
					})
					this.getgrid().insert(data)
					// this.$api.invoice.addmatchgoods({
					// 	cargoId:this.currentrow.cargoId,
					// 	goods:data,
					// }).then(()=>{
					// 	this.customreload()
					// })
					//console.log(data)
				}
			},
			goodsSubmit(e){
				if(e.data){
					let data = e.data.map((item)=>{
						return {
							groupcode:item.code,
							is_package:0,
							nums:null,
						}
					})
					this.getgrid().insert(data)
				}
			},
			list_beforeCreateGrid(gridOptions) {
				//console.log(this.invoicedata,456)
				let buttons = [
						{
							name: '线上商品（适用有规格）',
							status: 'primary',
							code: 'addfromonlinegoods'
						},{
							name: '云系统商品（兜底）',
							status: 'primary',
							code: 'addfromnazhi'
						},
				]
				if(this.invoicedata.orderPlant == 'xw'){
					buttons.unshift({
							name: '小望订单（适用有订单）',
							status: 'primary',
							code: 'addfromwxorder'
					},{
						name: '万里牛订单（适用有订单）',
						status: 'primary',
						code: 'addfromorder'
					})
				}
				if(this.invoicedata.orderPlant == 'nazhi'){
					buttons.unshift({
						name: '万里牛订单（适用有订单）',
						status: 'primary',
						code: 'addfromorder'
					})
				}
				gridOptions.height = 400
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: buttons,
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'groupcode',
						title: '商品编码',
						editRender: {
							name: '$input',
							props: {
								disabled: true
							},
							events: {
						
							}
						},
					}, {
						field: 'nums',
						title: '数量',
						editRender: {
							name: '$inputNumber',
							props: {
								min: 0,
							},
							events: {

							}
						},
					}, {
						field: 'tp_payment',
						title: '金额',
					},{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					nums: [{
						required: true,
						message: '缺少必填项【数量】',
					}],
					groupcode: [{
						required: true,
						message: '缺少必填项【商品编码】',
					}]
				}
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: []
					})
				})
			},
			modal_init(){
				this.sourceData = this.currentrow
				this.sourceData.amount = Math.abs(this.sourceData.amount)
				this.sourceData.orderId = this.invoicedata.orderId
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.logistictrace_custom_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			getgrid(){
				return this.$refs.invoiceDetailTable
			},
			addfromorder(){
				if(this.sourceData.orderId && this.sourceData.orderId!='无'){			
					this.checkeddata = this.getgrid().getTableData().tableData
					this.$nextTick(()=>{
						this.$refs.tradeBox.initList()
						this.$refs.tradeBox.box.alertBox()
					})
				}else{
					this.$message.error('暂无订单')
				}
				//this.getgrid().insert({})
			},
			addfromwxorder(){
				if(this.sourceData.orderId && this.sourceData.orderId!='无'){			
					this.checkeddata = this.getgrid().getTableData().tableData
					this.$nextTick(()=>{
						this.$refs.xwtradeBox.initList()
						this.$refs.xwtradeBox.box.alertBox()
					})
				}else{
					this.$message.error('暂无订单')
				}
				//this.getgrid().insert({})
			},
			
			
			addfromonlinegoods(){
				this.$refs.skuBox.initList()
				this.$refs.skuBox.box.alertBox()
				//this.getgrid().insert({})
			},
			addfromnazhi(){
				this.$refs.goodsBox.initList()
				this.$refs.goodsBox.box.alertBox()
				//this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData)=>{
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					// this.$api.logistictrace.updatefromlist(this.row.traceID,submitData).then(()=>{
					// 	this.$emit('success')
					// 	this.modal_cancel()
					// })
					this.getgrid().validate(true, (res) => {
						if (!res) {
							let submitData = JSON.parse(JSON.stringify(formData))
							this.submitDataFormater(submitData)
							let detail = this.getgrid().getTableData().tableData
							let data = {}
							data.main = submitData
							data.detail = detail
							//console.log(this.getgrid().getTableData())
							//this.createJson(data)
							//console.log(data,123123)
							this.$emit('success', {
								data: JSON.stringify(data)
							})
							
							console.log(data)
						} else {
							for (let i in res) {
								this.$message.error('缺少必填项：' + res[i][0].column.title)
							}
						}
					})
					//console.log(submitData)
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			tradeBox,
			xwtradeBox,
			skuBox,
			goodsBox
		}
	}
</script>